<template>
  <div>
    <b-button
        style="background-color: #185E8B"
        class="btn mt-4"
        size="lg"
        @click="loginModal"
    >{{$t('message.Tizimga_kirish')}}</b-button>

    <b-modal
        hide-footer
        id="admin-center"
        centered
        v-model="adminModal"
        :title="$t('message.Enter')">
      <label>{{$t('message.Log_in')}}</label>
      <b-form-input id="input-default" v-model="form.username"></b-form-input>
      <br>
      <label>{{$t('message.Password')}}</label>
      <b-form-input type="password" id="input-default" v-model="form.password"></b-form-input>
     <b-row>

       <b-col md="6">
         <b-button
             variant="warning"
             class="admin-btn"
             @click="handlePush">
           {{$t('message.Enter_school')}}
         </b-button>
       </b-col>
       <b-col
           md="6">
         <b-button
             variant="primary"
             class="admin-btn"
             @click="clickEnter">
           {{$t('message.Enter_moderator')}}
         </b-button>
       </b-col>
     </b-row>
    </b-modal>
  </div>
</template>

<script>
import {loginTheUser} from "../../../../api/auth";
import {
  setUserData,
  removeModeratorToken,
  removeSchoolToken, setModeratorToken,
  setSchoolToken,
  getSchoolToken,
  getModeratorToken,
} from "../../../../utils/auth";

export default {
  name: "AdminModal",
  data(){
    return{
      show: false,
      form: {
        username: "",
        password: "",
        type: "",
        token_name: "web",
      },
      adminModal: false,
    }
  },
  methods:{
    loginModal() {
      if(getSchoolToken()) {
        this.$router.push({ name: 'statistics' })
      }
      else if(getModeratorToken()) {
        this.$router.push({ name:'moderator-profile' })
      }
      else {
        this.adminModal = true;
      }
    },
    handlePush(){
      this.form.type = "school";
      loginTheUser(this.form).then(res => {
        setSchoolToken(res.data.token.plainTextToken);
        setUserData(JSON.stringify(res.data.user));
        removeModeratorToken()
        this.$router.push({ name: 'statistics' })
      })
    },
    clickEnter(){
      this.form.type = "moderator";
      this.form.name = this.form.username;
      loginTheUser(this.form).then(res => {
        setModeratorToken(res.data.token);
        setUserData(JSON.stringify(res.data.user));
        removeSchoolToken();
        this.$router.push({ name:'moderator-profile' })
      })
    }
  }
}
</script>
<style scoped>
.btn{
  margin-right: 10px;
  border-radius: 15px;
}
.admin-btn{
  margin-top: 25px;
  border-radius: 15px;
  margin-left: 20px;
}
</style>
